module.exports = __webpack_public_path__ + "static/media/TRIAL1-after-10-sek-if-wrong.8c69e6d6.mp3";